<div class="wrap">
  <img [src]="map" alt="carte-météo">
</div>


<!-- <div id="map" style="width: 100%;"></div>
<button id="show-weather">Weather</button>
<button id="show-wind">Wind</button>

<script src="https://code.sportysky.com/sportysky/1.0/api.sportysky.js"></script>
<script>
  body.addEventListener("DOMContentLoaded", function () {

    var onHoverSpot = function (spot, event) {
      switch (event.type) {
        case 'mousemove':
          // Do Something
          break;
        case 'mouseleave':
          // Do Something
          break
      }
    };

    var onClickSpot = function (spot, event) {
      // Do Something
    };

    var hasAqData = function (hasData) {
      if (!hasData) {
        // Do something
      } else {
        // Do something
      }
    };


    var map = new sportrizer.sportysky.Map(
      document.getElementById('map'),
      'https://dev-ffv2020.bizzdev.net/api/SportySky/spot', // Path to api.php
      {
        iconSize: 40, // Icon Size
        // iconSizeTiny: 15, // Icon Size Tiny
        // iconTinyBefore: 1024, // Break Width for display iconSize or iconSizeTiny
        // debug: false, // active or not debug for position
        // textWeather: '[AIRTEMPERATURE] °c', // Text under image for Weather 
        // textWind: '[WINDSPEED] Km/h', // Text Under image for Wind
        // textWindGust: '<br><em>(Max. [WINDGUST])</em>', // Text if Windgust
        // hoverSpot: onHoverSpot, // Callback function on Hover image
        // clickSpot: onClickSpot, // Callback function on Click image
        // hasAqData: hasAqData, // Callback function for hasAqData or not
      });

    // map.displayRegion(new Date(), 'FR-BRE'); // Displays Brittany (France)

    // window.onresize = function () {
    //   map.redraw();
    // }

    // document.getElementById('show-wind').onclick = function () {
    //   map.showWind();
    // }

    // document.getElementById('show-weather').onclick = function () {
    //   map.showWeather();
    // }

    // document.getElementById('show-aq').onclick = function () {
    //   map.showAQ();
    // };
  });

</script> -->
